module.exports = __webpack_public_path__ + "static/media/4gflota.ebe21180.png";